import {createSlice} from '@reduxjs/toolkit';

import {registerationBuilder} from './reducer';

const initialState: any = {
  loading: 0,
  error: '',
  stepNumberLoading: '',
  stepNumber: '',
  registerStatus: {},
  softwareTypes: [],
  deliveryTypes: []
};

export const registerationSlicer = createSlice({
  name: 'registeration',
  initialState,
  reducers: {},
  extraReducers: registerationBuilder
});

export default registerationSlicer.reducer;
